import { render, staticRenderFns } from "./orderCost.vue?vue&type=template&id=20198a84&scoped=true"
import script from "./orderCost.vue?vue&type=script&lang=js"
export * from "./orderCost.vue?vue&type=script&lang=js"
import style0 from "./orderCost.vue?vue&type=style&index=0&id=20198a84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20198a84",
  null
  
)

export default component.exports